export type GroupByReturn<T extends Record<string, any>, T2 extends keyof T> = {
  [K in T[T2]]: T extends { [_ in T2]: K } ? T[] : never;
};

export const groupBy = <T extends Record<string, any>, T2 extends keyof T>(
  sources: T[],
  key: T2 | ((s: T) => string)
): typeof key extends string ? GroupByReturn<T, T2> : Record<string, T[]> => {
  return sources.reduce<Record<string, T[]>>((s, source) => {
    const value = typeof key === 'function' ? key(source) : source[String(key)];
    if (value !== undefined) {
      if (!s[value]) {
        s[value] = [];
      }
      s[value].push(source);
    }
    return s;
  }, {}) as any;
};
